<template>
  <div class="box wrapper-detail-salary-receipt">
    <h2 class="title is-4 has-text-primary title-detail-salary-receipt">
      Detalle del Recibo de Salario
    </h2>
    <div class="columns is-multiline">
      <div class="column is-6 is-12-mobile">
        <BField
          label="Fecha del pago"
          label-for="paymentDate"
        >
          <BDatepicker
            id="paymentDate"
            :value="privatePaymentDate"
            :date-parser="dateParser"
            v-bind="calendarProps"
            icon="calendar-today"
            @input="onInput('paymentDate', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile">
        <BField
          label-for="paymentPeriodStart"
          label="Fecha inicial del pago"
        >
          <BDatepicker
            id="paymentPeriodStart"
            :value="privatePaymentPeriodStart"
            :date-parser="dateParser"
            v-bind="calendarProps"
            icon="calendar-import"
            @input="onInput('paymentPeriodStart', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile">
        <BField
          label-for="paymentPeriodEnd"
          label="Fecha final del pago"
        >
          <BDatepicker
            id="paymentPeriodEnd"
            :value="privatePaymentPeriodEnd"
            :date-parser="dateParser"
            v-bind="calendarProps"
            icon="calendar-export"
            @input="onInput('paymentPeriodEnd', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile">
        <BField
          label-for="earnedDays"
          label="Días pagados"
        >
          <BInput
            id="earnedDays"
            :value="privateEarnedDays"
            type="number"
            step="0.001"
            min="0"
            placeholder="14"
            icon="calendar-star"
            required
            @input="onInput('earnedDays', $event)"
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'PayrollDetails',
  data() {
    return {
      payrollTypeCatalog: [
        { value: 'O', label: 'Ordinaria' },
        { value: 'E', label: 'Extraordinaria' },
      ],
      privateType: 'O',
      calendarProps: {
        placeholder: 'DD/MM/AAAA',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        dayNames: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
        editable: true,
        dateFormatter: String => moment(String).format('DD/MM/YYYY'),
      },
    };
  },

  computed: {
    privatePaymentDate() {
      return moment(this.timestampToDate(this.$store.state.payroll.paymentDate)).toDate();
    },

    privatePaymentPeriodStart() {
      return moment(this.timestampToDate(this.$store.state.payroll.paymentPeriodStart)).toDate();
    },

    privatePaymentPeriodEnd() {
      return moment(this.timestampToDate(this.$store.state.payroll.paymentPeriodEnd)).toDate();
    },
    privateEarnedDays() {
      return this.$store.state.payroll.earnedDays;
    },
  },
  methods: {
    dateParser: date => moment(date).toDate(),
    timestampToDate(timestamp) {
      const parsedTimestamp = parseInt(timestamp, 10);
      // eslint-disable-next-line
      if (isNaN(parsedTimestamp)) return this.dateParser(timestamp);
      const timestampNumber = Number(timestamp) * 1000;
      const finalDate = new Date(timestampNumber);
      const strDate = `${(finalDate.getMonth() + 1)}/${finalDate.getDate()}/${finalDate.getFullYear()}`;
      return strDate;
    },
    onInput(name, event) {
      this.$store.commit('payroll/setValue', { accessor: name, value: event });
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 1rem;
}
</style>
